import { Component, OnInit } from '@angular/core';
import { SnotifyService } from 'ng-snotify';
import * as moment from 'moment';
import { RowAction } from 'src/app/shared/base-reporting/models/row-actions.interface';
import { FilterItem } from 'src/app/shared/base-reporting/models/filter-item.interface';
import { FilterCallback } from 'src/app/shared/base-reporting/models/filter-callback.interface';
import { RowActionCallback } from 'src/app/shared/base-reporting/models/row-action-callback.interface';
import { Invite } from 'src/app/shared/models/invites.model';
import { InvitesService } from '../invites.service';

@Component({
  selector: 'app-invites-list',
  templateUrl: './invites-list.component.html',
  styleUrls: ['./invites-list.component.css']
})
export class InvitesListComponent implements OnInit {
  invite = new Invite();
  tableColumns = ['email', 'expired', 'expiresAt', 'roleId', 'tokenUsed'];
  rowActions: Array<RowAction> = [
    {
      type: 'icon',
      slug: 'resendInvite',
      class: 'btn',
      iconClasses: 'fa fa-share'
    }
  ];
  reportFilter: Array<FilterItem> = [
    {
      fieldName: 'email',
      fieldDisplayName: 'Email ',
      fieldType: 'text'
    },
    {
      fieldName: 'expiresAt',
      fieldDisplayName: 'Expires At ',
      fieldType: 'daterange'
    },
    {
      fieldName: 'expired',
      fieldDisplayName: 'Expired ',
      fieldType: 'select',
      multiple: false,
      hasSelectAll: false,
      defaultValue: null,
      options: [
        { value: 'true', display: 'True' },
        { value: 'false', display: 'False' },
        { value: '', display: 'All'}

      ]
    }
  ];
  private Data = [] as Array<TableViewItem>;
  currentFilterObject = {} as FilterModel;
  constructor(
    private invitesApi: InvitesService,
    private notifier: SnotifyService,
  ) {}

  get data(): Array<TableViewItem> {
    return this.Data.filter(row => {
      if (
        this.currentFilterObject.expiresAt &&
        this.currentFilterObject.expiresAt.startDate &&
        this.currentFilterObject.expiresAt.endDate
      ) {
        return moment(row.expiresAt).isBetween(
          // @ts-ignore
          this.currentFilterObject.expiresAt.startDate._i,
          // @ts-ignore
          this.currentFilterObject.expiresAt.endDate._i
        );
      } else {
        return true;
      }
    }).filter(row => {
      if (this.currentFilterObject.email) {
        return row.email.includes(this.currentFilterObject.email);
      }
      return true;
    })
    .filter(row => {
      if (this.currentFilterObject.expired) {
        return row.expired
          .includes(String(this.currentFilterObject.expired));
      }
      return true;
    });
  }
  set data(v: Array<TableViewItem>) {
    this.Data = v;
  }

  ngOnInit() {
    // this.sharedService.getLanguages().then(response => {
    //   this.reportFilter[1].options = response.data.languages.map(l => ({value: l.id, display: l.name}))
    // })

    this.fetchAllInvites();
  }

  onFilter(event: FilterCallback) {
    this.currentFilterObject = event.filter;
  }

  private fetchAllInvites() {
    this.invitesApi.getAllInvites().subscribe(response => {
      // console.log(response)
      this.data = response.data.invitations.map(r => {
        const expire = this.checkDate(r.expiresAt);
        return {
          id: r.id,
          email: r.email,
          roleId: r.roleId,
          expiresAt: r.expiresAt,
          expired: String(expire),
          tokenUsed: r.tokenUsed
        } as TableViewItem;
      });
    });
  }
  rowActionCB(event: RowActionCallback) {
    switch (event.action) {
      case 'resendInvite':
        this.invite = event.on;
        this.resendInvite(this.invite);
        break;
      default:
        console.error('this is a mistake!');
    }
  }
  fetchTable(event) {
    if (event[`flag`] === true) {
      this.fetchAllInvites();
    }
  }
  resendInvite(row) {
    this.invitesApi.resendInvite({ id: row.id }).subscribe(
      Response => {
        // console.log(Response);
        this.notifier.success(
          row.email + ' Invitation Link Has Sent Successfully'
        );
      },
      err => {
        this.notifier.error('This Invitation Link Has Sended Before');
      }
    );
  }
  checkDate(date): boolean {
    return moment(date).isBefore(
      // @ts-ignore
      moment()
    );
  }
}

interface TableViewItem {
  email?: string;
  roleId?: number;
  expired?: string;
  expiresAt?: string;
  tokenUsed?: boolean;
}

interface FilterModel {
  email?: string;
  expiresAt?: DateRangeModel;
  expired?: boolean;
}

interface DateRangeModel {
  startDate?: moment.Moment;
  endDate?: moment.Moment;
}

